export default ({ request }) => ({
  shipmentCustomsCodeListApi(data = {}) {
    return request({
      url: '/factory/shipment/customs/code/list',
      method: 'post',
      data,
    })
  },
  shipmentCustomsCodeSelectApi(data = {}) {
    return request({
      url: '/factory/shipment/customs/code/select',
      method: 'post',
      data,
    })
  },
  shipmentCustomsCodeDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/customs/code/detail',
      method: 'post',
      data,
    })
  },
  shipmentCustomsCodeSaveApi(data = {}) {
    return request({
      url: '/factory/shipment/customs/code/save',
      method: 'post',
      data,
    })
  },
  shipmentCustomsCodeDelApi(data = {}) {
    return request({
      url: '/factory/shipment/customs/code/del',
      method: 'post',
      data,
    })
  },
})
